import { Subject } from 'rxjs'

import { take } from 'rxjs/operators'

export default class Signal
{
	private subject: Subject<any>

	constructor()
	{
		if (this.constructor === Signal)
		{
			throw new Error('Signal is an abstract class and cannot be instantiated')
		}

		this.subject = new Subject()
	}

	asObservable()
	{
		return this.subject.asObservable()
	}

	asObservableOnce()
	{
		return this.asObservable().pipe(take(1))
	}

	fire(...args)
	{
		const argSize = arguments.length
		if (argSize <= 0)
		{
			this.subject.next()
		}
		else if (argSize === 1)
		{
			this.subject.next(arguments[0])
		}
		else if (argSize > 1)
		{
			this.subject.next(arguments)
		}
	}
}
